import { createSlice } from "@reduxjs/toolkit";

export const authSlice = createSlice({
  name: "auth",
  initialState: {
    value: null,
    usuario: "",
    menu: [],
    acciones: [],
  },
  reducers: {
    login: (state) => {
      state.value = true;
    },
    logout: (state) => {
      state.value = false;
    },
    setUsuario: (state, action) => {
      state.usuario = action.payload;
    },
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
    setAcciones: (state, action) => {
      state.acciones = action.payload;
    },
  },
});

export const {
  login,
  logout,
  setUsuario,
  setMenu,
  setAcciones,
} = authSlice.actions;

export const selectAuth = (state) => state.auth.value;
export const selectUsuario = (state) => state.auth.usuario;
export const selectMenu = (state) => state.auth.menu;
export const selectAcciones = (state) => state.auth.acciones;

export default authSlice.reducer;
